import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Balance: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Basecost: ", -1)
const _hoisted_5 = { class: "font-bold text-primary" }
const _hoisted_6 = { class: "font-bold text-primary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Supporter: ", -1)
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-xs text-light" }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.sellerTeam)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.sellerTeam.name) + " ", 1),
          false
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 0,
                placement: "top",
                width: "auto",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoFilled)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { class: "font-bold" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.sellerTeam.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "mt-3" }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createTextVNode(" " + _toDisplayString(_ctx.sellerTeam.manager?.email), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "mt-3" }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(_ctx.sellerTeam.balance?.amount)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "mt-3" }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createElementVNode("span", _hoisted_5, [
                            _createVNode(_component_router_link, { to: {
                  path: `/ag/base-cost`,
                } }, {
                              default: _withCtx(({ href }) => [
                                _createVNode(_component_el_link, {
                                  href: href,
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.sellerTeam.basecost?.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { class: "mt-3" }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.sellerTeam.supporter?.email), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_8, [
      _createElementVNode("p", {
        title: _ctx.sellerTeam.manager?.email
      }, _toDisplayString(_ctx.sellerTeam.manager?.email), 9, _hoisted_9)
    ]),
    _createElementVNode("span", _hoisted_10, [
      _createElementVNode("p", {
        title: _ctx.props.scope.row?.store?.appShopUrl
      }, _toDisplayString(_ctx.props.scope.row?.store?.appShopUrl), 9, _hoisted_11),
      (_ctx.props.scope.row?.store?.domain)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            title: _ctx.props.scope.row?.store?.domain
          }, _toDisplayString(_ctx.getStoreDomain(_ctx.props.scope.row?.store)), 9, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    (_ctx.props.scope.row?.requestSellerStatus)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          class: "custom-text-mini",
          title: _ctx.props.scope.row?.requestSellerComment,
          size: "small",
          type: 
      _ctx.props.scope.row?.requestSellerStatus === 'requested'
        ? 'warning'
        : 'success'
    
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.props.scope.row?.requestSellerReasonCode), 1)
          ]),
          _: 1
        }, 8, ["title", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}